// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.persona.RentalManagerUserPersonaLinkWebApiHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import {
  RentalManagerUserPersonaLinkWebApiHandler_getLink,
  RentalManagerUserPersonaLinkWebApiHandler_getLink_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type { RentalManagerGetPersonaLinkResponseDto } from '@zg-rentals/ts-rental-manager-api-client';

export type RentalManagerUserPersonaLinkWebApiHandler_getLink_Options = UseQueryOptions<
  RentalManagerGetPersonaLinkResponseDto,
  unknown,
  RentalManagerGetPersonaLinkResponseDto,
  Array<string>
>;

const RentalManagerUserPersonaLinkWebApiHandler_getLink_GetKey = () => [
  RentalManagerUserPersonaLinkWebApiHandler_getLink_Path,
];

/**
 * Get persona inquiry link for a user
 */
export const useRentalManagerUserPersonaLinkWebApiHandler_getLink = (
  options: Omit<RentalManagerUserPersonaLinkWebApiHandler_getLink_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerUserPersonaLinkWebApiHandler_getLink_GetKey(),
    queryFn: () => RentalManagerUserPersonaLinkWebApiHandler_getLink(),
  });
};
useRentalManagerUserPersonaLinkWebApiHandler_getLink.getKey = RentalManagerUserPersonaLinkWebApiHandler_getLink_GetKey;
